import React, { useState } from "react"
import style from "./transcript.mod.scss"
import PropTypes from "prop-types"
import { Button } from "@components"

const Transcript = ({
  html,
  id = "video-transcript",
  heading = "transcript"
}) => {
  const [isOpen, setOpen] = useState(false)

  if (!html) return null

  return (
    <div className={style.transcript}>
      <div className={style.transcript__button}>
        <Button
          type="button"
          onClick={() => setOpen(!isOpen)}
          aria-expanded={isOpen}
          aria-controls={id}
          children={isOpen ? `Hide the ${heading}` : `Read the ${heading}`}
        />
      </div>
      {isOpen && (
        <div
          id={id}
          className={style.transcript__body}
          dangerouslySetInnerHTML={{ __html: html }}
        />
      )}
    </div>
  )
}

Transcript.propTypes = {
  html: PropTypes.string,
  id: PropTypes.string,
  heading: PropTypes.string
}

export default Transcript
